  document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("common-product-countdown")) {
      class CommonProductCountdown extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute("section-id") || "";
          this.countdownTime = this.getAttribute("countdown-time");
          this.daysEl = this.querySelector(".days span");
          this.hoursEl = this.querySelector(".hours span");
          this.minutesEl = this.querySelector(".minutes span");
          this.secondsEl = this.querySelector(".seconds span");
          this.localeZoneOffset = (new Date().getTimezoneOffset() / -60 - 8) * 60 * 60 * 1000;
          this.endTime = new Date(this.countdownTime);
          this.endTimeNumber = this.endTime.getTime();
          
          this.interval = null;
          this.isVisible = false; 
          this.observer = null;
        }

        connectedCallback() {
          this.initObserver();
        }

        disconnectedCallback() {
          if (this.interval) clearInterval(this.interval);
          if (this.observer) this.observer.disconnect();
        }

        initObserver() {
          const options = {
            root: null, 
            threshold: 0.01 
          };

          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.startCountdown();
              } else {
                this.pauseCountdown();
              }
            });
          }, options);

          this.observer.observe(this);
        }

        startCountdown() {
          if (this.isVisible) return; 
          this.isVisible = true;

          this.updateCountdown();
          this.interval = setInterval(() => this.updateCountdown(), 1000);
        }

        pauseCountdown() {
          if (!this.isVisible) return; 
          this.isVisible = false;

          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        }

        updateCountdown() {
          const now = new Date();
          
          let milliseconds = this.endTimeNumber - now.getTime() + this.localeZoneOffset;
          milliseconds = Math.max(milliseconds, 0); 

          const days = Math.floor(milliseconds / (86400000)); // 1000 * 60 * 60 * 24
          const hours = Math.floor((milliseconds / (3600000)) % 24); // 1000 * 60 * 60
          const minutes = Math.floor((milliseconds / (60000)) % 60); // 1000 * 60
          const seconds = Math.floor((milliseconds / 1000) % 60);

          this.daysEl.textContent = String(days).padStart(2, "0");
          this.hoursEl.textContent = String(hours).padStart(2, "0");
          this.minutesEl.textContent = String(minutes).padStart(2, "0");
          this.secondsEl.textContent = String(seconds).padStart(2, "0");
          if (milliseconds === 0) {
            this.pauseCountdown();
          }
        }
      }

      customElements.define("common-product-countdown", CommonProductCountdown);
    }
  });